<template>
  <div class="member card card-lg">
    <edit-payment v-if="view === 'payment'" />
    <edit-password v-else-if="view === 'password'" />
    <edit-plan v-else-if="view === 'edit'" />
    <extend-plan v-else-if="view === 'extend'" />
    <edit-profile v-else-if="view === 'profile'" />
    <cancel-subscription v-else-if="view === 'cancel'" />
    <home v-else v-model="view" />
  </div>
</template>
<script>
import updateQuery from '@/mixins/updateQuery'
export default {
  data () {
    return {
      nrSteps: 4,
    }
  },
  mixins: [updateQuery],
  components: {
    CancelSubscription: () => import('./CancelSubscription.vue'),
    EditPayment: () => import('./EditPayment.vue'),
    EditPassword: () => import('./EditPassword.vue'),
    EditPlan: () => import('./EditPlan.vue'),
    ExtendPlan: () => import('./ExtendPlan.vue'),
    EditProfile: () => import('./EditProfile.vue'),
    Home: () => import('./Home.vue'),
  },
  computed: {
    view: {
      set (x) {
        if (x === 'buy') {
          this.$router.push({
            name: 'signup',
            query: {
              step: 2,
            },
          })
          return
        }
        this.__pushQuery('view', x)
      },
      get () {
        return this.$route.query['view']
      },
    },
  },
}
</script>

<style lang="less">
@import '../../style/variables.less';
.member {
  align-self: flex-start;
  // align-items: stretch;

  section {
    text-align: left;
    .row {
      justify-content: flex-start;
    }
  }
  strong {
    font-family: Oswald;
  }
  section:not(:last-child) {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid @color-grey;
  }
}
.plan {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: @color-grey;
  padding: 3em;
  header {
    color: white;
    font-family: Oswald;
    font-size: 2.4rem;
    font-weight: 500;
    margin-bottom: 16px;
  }
  strong {
    display: inline-block;
    color: white;
    margin: 10px 0;
  }
  .card-details {
    margin-top: 10px;
    display: flex;
    align-items: center;
    .icon {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }
  }
}
.last-button {
  margin-top: 16px;
  align-self: flex-end;
}
</style>
